





































































































































import Vue from 'vue';
import Page from '../components/Page.vue';
import GrievanceForm from '../components/grievance/GrievanceForm.vue';
import IdentificationForm from '../components/identification/IdentificationForm.vue';
import Radio from '../components/common/form/Radio.vue';
import FormInput from '../components/common/form/FormInput.vue';
import { createNamespacedHelpers, mapState as mapRootState, mapActions as mapRootActions } from 'vuex';
import PrimaryButton from '../components/common/buttons/PrimaryButton.vue';
import Checkbox from '../components/common/form/Checkbox.vue';
import Card from '../components/common/Card.vue';
import PaginatedSingleSelect from '../components/common/form/PaginatedSingleSelect.vue';
import Errors from '../components/common/form/Errors.vue';
import _ from 'lodash';
import { TermsAndConditionsType } from '@/store/types';
const { mapState, mapMutations, mapActions, mapGetters } = createNamespacedHelpers('grievanceForm');
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
const mapConfirmState = createNamespacedHelpers('confirm').mapState;
export default Vue.extend({
    components: {
        PaginatedSingleSelect,
        Card,
        Checkbox,
        PrimaryButton,
        FormInput,
        Radio,
        IdentificationForm,
        GrievanceForm,
        Page,
        Errors,
    },
    data: function() {
        return {
            siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            TermsAndConditionsType: TermsAndConditionsType,
            isSubmitting: false,
        };
    },
    computed: {
        ...mapCustomLabelsState([
            'termsAndConditionsType',
            'termsAndConditionsText',
            'termsAndConditionsUrl',
            'privacyPolicyUrl',
            'createGrievanceTitle',
            'portalTitle',
            'instanceTitle',
            'customTermsAndConditions',
        ]),
        ...mapRootState(['locale']),
        ...mapGetters(['getFieldErrors', 'isFormValid', 'isFieldVisible', 'getFieldLabel']),
        ...mapState([
            'referer',
            'firstTimeUsed',
            'acceptTerms',
            'description',
            'anonymous',
            'notification',
            'firstName',
            'lastName',
            'email',
            'isSaving',
            'isUploading',
            'customTextarea1',
            'customTextarea1Toggle',
            'customTextarea2',
        ]),
        ...mapConfirmState(['refNo']),
    },
    async beforeRouteEnter(to, from, next) {
        const store = require('@/store').default;
        await store.dispatch('grievanceForm/initForm');
        next();
    },
    created() {
        document.title = `${this.instanceTitle} | ${this.createGrievanceTitle} | ${this.portalTitle}`;
        this.$recaptchaInstance?.showBadge();
        if (this.termsAndConditionsType === TermsAndConditionsType.TEXT_WITHOUT_CHECKBOX) {
            this.setAcceptTerms({ acceptTerms: true });
        }
    },
    destroyed() {
        this.$recaptchaInstance?.hideBadge();
    },
    methods: {
        findFirstErrorId(): string | null {
            let fieldId = null;
            if (this.anonymous) {
                fieldId = _.find(
                    [
                        'type',
                        'parentCategory',
                        'category',
                        'description',
                        'customTextarea1',
                        'customTextarea1Toggle',
                        'customTextarea2',
                        'attachFiles',
                        'email',
                        'firstTimeUsed',
                        'referer',
                        'acceptTerms',
                        'global',
                        'customSingle1',
                        'customSingle2',
                        'projectIdMap',
                    ],
                    fieldId => {
                        if (this.getFieldErrors(fieldId)) return fieldId;
                    },
                );
            } else {
                fieldId = _.find(
                    [
                        'type',
                        'parentCategory',
                        'category',
                        'description',
                        'customTextarea1',
                        'customTextarea1Toggle',
                        'customTextarea2',
                        'attachFiles',
                        'title',
                        'firstName',
                        'lastName',
                        'email',
                        'phone',
                        'ageGroup',
                        'ethnicGroup',
                        'firstTimeUsed',
                        'referer',
                        'acceptTerms',
                        'addressLine1',
                        'addressLine2',
                        'neighborhood',
                        'sublocality',
                        'city',
                        'state',
                        'country',
                        'postalCode',
                        'sublocality2',
                        'arealevel2',
                        'global',
                        'customSingle1',
                        'customSingle2',
                        'projectIdMap',
                    ],
                    fieldId => {
                        if (this.getFieldErrors(fieldId)) return fieldId;
                    },
                );
            }

            return fieldId ? (fieldId as string) : null;
        },
        async submit() {
            if (this.isSubmitting) {
                return;
            }

            this.isSubmitting = true;

            try {
                if (this.$data.siteKey) {
                    await this.$recaptchaLoaded();
                    const token = await this.$recaptcha('submit');
                    this.setRecaptchaVerifyId({ recaptchaVerifyId: token });
                }

                await this.saveGrievance();

                if (!this.isFormValid) {
                    const firstErrorId = this.findFirstErrorId();
                    this.isSubmitting = false;
                    if (firstErrorId) {
                        this.$el.querySelector(`#${firstErrorId}`)?.scrollIntoView();
                        //this return shall be call only when we have an error.
                        //If we are anonymous, we should not validate certain fields even if the form "has" error
                        return;
                    }
                }
                this.resetForm();
                this.$router.push(`/${this.$route.params.instanceId}/confirm/${this.refNo}`);
            } finally {
                this.isSubmitting = false;
            }
        },
        ...mapMutations(['setReferer', 'setFirstTimeUsed', 'setAcceptTerms', 'resetForm', 'setRecaptchaVerifyId']),
        ...mapActions(['saveGrievance', 'initForm']),
        ...mapRootActions(['addError']),
        handleError(error: Error) {
            this.addError({ error });
        },
        showTermsAndConditionsText(event: MouseEvent) {
            if (event.target instanceof Element && event.target.classList.contains('link')) {
                this.$bvModal.show('terms-and-conditions');
                event.preventDefault();
                event.stopPropagation();
            }
        },
        acceptTermsUrl(privacyPolicyUrl: string, termsAndConditionsUrl: string) {
            if (privacyPolicyUrl) {
                return this.$t('acceptTermsUrl', { privacyPolicyUrl, termsAndConditionsUrl });
            } else {
                return this.$t('acceptTermsUrlWithoutPolicy', { termsAndConditionsUrl });
            }
        },

        acceptTermsText(privacyPolicyUrl: string, customTermsAndConditions?: string) {
            if (customTermsAndConditions) {
                return customTermsAndConditions;
            }
            if (privacyPolicyUrl) {
                return this.$t('acceptTermsText', { privacyPolicyUrl });
            }
            return this.$t('acceptTermsTextWithoutPolicy');
        },
    },
});
